/**
 * The country's window is a hard limit (user, 12/10/2026: "the window is the
 * hard limit — if we set 00–06 AM and the peak is 7 AM, forget it"): no drop
 * is planned at a local time outside it — not a slot drop, not an optimizer
 * extra, not the probe. Wall-clock: a minute is judged by its time of day
 * (minutes past 1439 are the next date, same clock); the end is excluded
 * (09:00–21:00 takes 20:59, not 21:00); an end at or before the start wraps
 * past midnight (22:00–06:00); start = end is the whole day. The planner and
 * the editor read this one rule. A container — or a single drop — may lift it
 * on purpose (14/10/2026: `sendOutsideWindow`).
 * For Media Devoted | Created By Ciro Autiero
 */

export interface CountryWindow {
  /** Recipient-local minutes from midnight, 0..1439. */
  startMin: number;
  endMin: number;
}

const DAY = 1440;

/** Is this planned minute (0..2879) inside the window, on the recipients' clock? */
export function inCountryWindow(minute: number, w: CountryWindow): boolean {
  const t = ((minute % DAY) + DAY) % DAY;
  if (w.startMin === w.endMin) return true;
  return w.startMin < w.endMin
    ? t >= w.startMin && t < w.endMin
    : t >= w.startMin || t < w.endMin;
}

/** No window at all — start = end is the whole day. */
export const WHOLE_DAY: CountryWindow = { startMin: 0, endMin: 0 };

/** The window a container's drops obey: the country's, or none when the
 *  container sends outside it (14/10/2026 — the hard limit, lifted on purpose). */
export function containerWindow(
  window: CountryWindow,
  sendOutsideWindow: boolean | undefined,
): CountryWindow {
  return sendOutsideWindow ? WHOLE_DAY : window;
}

/** "09:00–21:00" — the window in the planner's sentences. */
export function windowLabel(w: CountryWindow): string {
  const hhmm = (m: number) =>
    `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
  return `${hhmm(w.startMin)}–${hhmm(w.endMin)}`;
}
